import { render, staticRenderFns } from "./HomeAds.vue?vue&type=template&id=55bbe596&scoped=true&"
import script from "./HomeAds.vue?vue&type=script&lang=js&"
export * from "./HomeAds.vue?vue&type=script&lang=js&"
import style0 from "./HomeAds.vue?vue&type=style&index=0&id=55bbe596&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bbe596",
  null
  
)

export default component.exports